import { LanguageTestQuestion } from '../../lib/types/models/language-test/language-test-question'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export const getMissingQuestions = (submissionId: number) => {
  return restApiClient
    .url(constructApiUrl(API.languageTest.getMissingQuestions.url, { submissionId }))
    .get<LanguageTestQuestion[]>()
}
